import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface CandidateContentProps {
  candidateInfo: any;
}

const CandidateContent: React.FC<CandidateContentProps> = ({
  candidateInfo,
}) => {
  const summary =
    candidateInfo?.introduction ||
    candidateInfo?.summary ||
    candidateInfo?.profileSummary ||
    '';

  const strengths = candidateInfo?.strengths || [];
  const gaps =
    candidateInfo?.gapsConcerns ||
    candidateInfo?.gaps ||
    candidateInfo?.concerns ||
    [];

  const recommendation = candidateInfo?.recommendation || '';
  const justification = candidateInfo?.justification || '';

  return (
    <Box className="content-wrapper">
      {/* Summary Section */}
      <Box className="section-card">
        <Box className="section-header">
          <Typography variant="h2">Summary</Typography>
        </Box>
        <Box className="section-body">
          <span>{summary || 'No summary available.'}</span>
        </Box>
      </Box>

      {/* Matched Skills Section */}
      {/* <Box className="section-card">
        <Box className="section-header">
          <Typography variant="h2">Matched Skills</Typography>
        </Box>
        <Box className="section-body">
          {candidateInfo?.matchedSkills?.length > 0 ? (
            <ul>
              {candidateInfo.matchedSkills.map(
                (skill: string, index: number) => (
                  <li key={index}>{skill}</li>
                ),
              )}
            </ul>
          ) : (
            <span>No matched skills available.</span>
          )}
        </Box>
      </Box> */}

      {/* Strengths & Gaps Row */}
      <Box className="split-sections">
        {/* Strengths */}
        <Box className="section-card">
          <Box className="section-header">
            <Typography variant="h2" className="strengths-header">
              ✅ Strengths
            </Typography>
          </Box>
          <Box className="section-body">
            {strengths.length > 0 ? (
              <ul>
                {strengths.map((strength: string, index: number) => (
                  <li key={index}>{strength}</li>
                ))}
              </ul>
            ) : (
              <span>No strengths listed.</span>
            )}
          </Box>
        </Box>

        {/* Gaps/Concerns */}
        <Box className="section-card">
          <Box className="section-header">
            <Typography variant="h2" className="gaps-header">
              <ReportProblemOutlinedIcon />
              Gaps/Concerns
            </Typography>
          </Box>
          <Box className="section-body">
            {gaps.length > 0 ? (
              <ul>
                {gaps.map((gap: string, index: number) => (
                  <li key={index}>{gap}</li>
                ))}
              </ul>
            ) : (
              <span>No gaps or concerns identified.</span>
            )}
          </Box>
        </Box>
      </Box>

      {/* Recommendation Section */}
      <Box className="section-card">
        <Box className="section-header">
          <Typography variant="h2" className="gaps-header">
            <EmojiObjectsOutlinedIcon />
            Recommendation
          </Typography>
        </Box>
        <Box className="section-body">
          {recommendation || justification ? (
            <span>
              {recommendation && <strong>{recommendation}</strong>}
              {recommendation && justification && ' - '}
              {justification}
            </span>
          ) : (
            <span>No recommendation provided.</span>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CandidateContent;
